import React, { useEffect, useState } from "react";
import { Alert, Button, Form, InputGroup, Spinner } from "react-bootstrap";
import { FiCheckCircle, FiEye, FiEyeOff, FiLock, FiRefreshCw, FiUser, FiXCircle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import api, { BASE_URL } from "../../Utils/api";
import "./Login.css";
import "./AtivacaoEntidade.css";


const AceitarConvite = () => {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [estado, setEstado] = useState(token ? "formulario" : "erro");
  const [mensagem, setMensagem] = useState(
    token ? "" : "Link de convite não informado."
  );
  const [entidade, setEntidade] = useState("");
  const [nome, setNome] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [reenviando, setReenviando] = useState(false);
  const [mensagemReenvio, setMensagemReenvio] = useState("");

  useEffect(() => {
    document.body.classList.add("login-page-body");
    return () => document.body.classList.remove("login-page-body");
  }, []);

  useEffect(() => {
    if (estado !== "sucesso") return undefined;
    const timer = window.setTimeout(
      () => navigate("/login", { replace: true }),
      5000
    );
    return () => window.clearTimeout(timer);
  }, [estado, navigate]);

  const aceitar = async (event) => {
    event.preventDefault();
    if (senha.length < 6 || senha.length > 128) {
      setMensagem("A senha deve possuir entre 6 e 128 caracteres.");
      return;
    }
    if (senha !== confirmacao) {
      setMensagem("As senhas informadas não coincidem.");
      return;
    }

    setEnviando(true);
    setMensagem("");
    try {
      const { data } = await api.post(`${BASE_URL}/api/auth/aceitar-convite`, {
        token,
        nome,
        senha,
      });
      setEntidade(data?.entidade || "");
      setMensagem(data?.message || "Conta criada com sucesso.");
      setEstado("sucesso");
    } catch (err) {
      setMensagem(
        err?.response?.data?.message ||
          "Não foi possível aceitar este convite."
      );
      setEstado("erro");
    } finally {
      setEnviando(false);
    }
  };

  const reenviar = async () => {
    setReenviando(true);
    setMensagemReenvio("");
    try {
      const { data } = await api.post(
        `${BASE_URL}/api/auth/reenviar-convite`,
        { token }
      );
      setMensagemReenvio(data?.message || "Solicitação registrada.");
    } catch {
      setMensagemReenvio(
        "Não foi possível solicitar o reenvio neste momento."
      );
    } finally {
      setReenviando(false);
    }
  };

  return (
    <div id="login-page">
      <main className="activation-container">
        <section className="activation-card" aria-live="polite">
          {estado === "formulario" && (
            <>
              <span className="activation-eyebrow">Convite recebido</span>
              <h1>Crie sua conta</h1>
              <p>Defina seu nome e uma senha para acessar a entidade que te convidou.</p>

              {mensagem && (
                <Alert variant="danger" className="activation-alert text-start">
                  {mensagem}
                </Alert>
              )}

              <Form onSubmit={aceitar} className="text-start">
                <Form.Group controlId="convite-nome" className="mb-3">
                  <Form.Label>Nome</Form.Label>
                  <InputGroup>
                    <InputGroup.Text><FiUser /></InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={nome}
                      onChange={(event) => setNome(event.target.value)}
                      placeholder="Seu nome completo"
                      maxLength={255}
                      required
                      autoFocus
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group controlId="convite-senha" className="mb-3">
                  <Form.Label>Senha</Form.Label>
                  <InputGroup>
                    <InputGroup.Text><FiLock /></InputGroup.Text>
                    <Form.Control
                      type={mostrarSenha ? "text" : "password"}
                      value={senha}
                      onChange={(event) => setSenha(event.target.value)}
                      minLength={6}
                      maxLength={128}
                      autoComplete="new-password"
                      required
                    />
                    <Button
                      type="button"
                      variant="outline-secondary"
                      onClick={() => setMostrarSenha((valor) => !valor)}
                      aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                    >
                      {mostrarSenha ? <FiEyeOff /> : <FiEye />}
                    </Button>
                  </InputGroup>
                </Form.Group>

                <Form.Group controlId="convite-confirmar-senha" className="mb-3">
                  <Form.Label>Confirme a senha</Form.Label>
                  <InputGroup>
                    <InputGroup.Text><FiLock /></InputGroup.Text>
                    <Form.Control
                      type={mostrarSenha ? "text" : "password"}
                      value={confirmacao}
                      onChange={(event) => setConfirmacao(event.target.value)}
                      minLength={6}
                      maxLength={128}
                      autoComplete="new-password"
                      required
                    />
                  </InputGroup>
                </Form.Group>

                <Button
                  type="submit"
                  className="btn-app-primary activation-primary"
                  disabled={enviando}
                >
                  {enviando ? <Spinner animation="border" size="sm" /> : "Aceitar convite e criar conta"}
                </Button>
              </Form>
            </>
          )}

          {estado === "sucesso" && (
            <>
              <FiCheckCircle className="activation-icon activation-icon-success" />
              <span className="activation-eyebrow">Convite aceito</span>
              <h1>Conta criada</h1>
              <p>{mensagem}</p>
              {entidade && <div className="activation-entity">{entidade}</div>}
              <small className="activation-redirect-note">
                Você será direcionado ao login em alguns segundos.
              </small>
              <Button
                className="btn-app-primary activation-primary"
                onClick={() => navigate("/login", { replace: true })}
              >
                Ir para o login
              </Button>
            </>
          )}

          {estado === "erro" && (
            <>
              <FiXCircle className="activation-icon activation-icon-error" />
              <span className="activation-eyebrow">Convite pendente</span>
              <h1>Este link não pôde ser utilizado</h1>
              <p>{mensagem}</p>

              {token && (
                <>
                  {mensagemReenvio && (
                    <Alert variant="info" className="activation-alert">
                      {mensagemReenvio}
                    </Alert>
                  )}
                  <Button
                    className="btn-app-primary activation-primary"
                    onClick={reenviar}
                    disabled={reenviando}
                  >
                    {reenviando ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <>
                        <FiRefreshCw /> Solicitar novo convite
                      </>
                    )}
                  </Button>
                </>
              )}

              <Button
                variant="link"
                className="activation-login-link"
                onClick={() => navigate("/login", { replace: true })}
              >
                Voltar para o login
              </Button>
            </>
          )}
        </section>
      </main>
    </div>
  );
};

export default AceitarConvite;
